/* eslint-disable import/no-anonymous-default-export */
import {
  ActivityStatus,
  AppStateDevicesStatus,
  BCGStatus,
  BedStatusValue,
  BioPatchStatus,
  BluetoothStatus,
  DevicesStatusMap,
  DeviceStatus,
  DeviceStatusesNames,
  EMPTY_POSTURE_STATUS,
  OccupancyStatus,
  parsePosture,
  PostureStatus,
  PostureStatusNumbers,
  PostureStatusValue,
  PowerStatus,
  SensorsStatus,
  UserNearbySettingsStatus,
  UserNearbyStatus,
} from ".";
import { DeviceResidentDTO } from "../devices";
import {
  DeviceActionType,
  DEVICES,
  IAddDeviceBySocket,
  IDeleteDeviceBySocket,
  IGetDeviceStatusesSuccess,
} from "../devices/types";
import { HEALTH_CHECK } from "../healthCheck/types";
const initialState: AppStateDevicesStatus = {
  bcgStatuses: {},
  callibrationStatuses: {},
  firmwareStatuses: {},
  powerStatuses: {},
  wifiStatuses: {},
  sensorsStatuses: {},
  activityStatuses: {},
  bluetoothStatuses: {},
  postureStatuses: {},
  occupancyStatuses: {},
  onOffStatuses: {},
  userNearbyStatuses: {},
  userNearbySettingsStatuses: {},
  isLoading: undefined,
};

const reducer = (
  state = initialState,
  action: DeviceActionType
): AppStateDevicesStatus => {
  switch (action.type) {
    case HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN: {
      return initialState;
    }
    case DEVICES.GET_ALL_DEVICES_STATUSES_REQUEST:
      return { ...state, isLoading: true };
    case DEVICES.GET_ALL_DEVICE_STATUSES_FAILURE:
      return { ...state, isLoading: false };
    case DEVICES.GET_ALL_DEVICE_STATUSES_SUCCESS: {
      const items = action.payload;
      const bcgStatuses = {};
      const callibrationStatuses = {};
      const firmwareStatuses = {};
      const powerStatuses = {};
      const wifiStatuses = {};
      const sensorsStatuses = {};
      const activityStatuses = {
        ...state.activityStatuses,
      } as DevicesStatusMap;
      const bluetoothStatuses = {};
      const postureStatuses = {};
      const occupancyStatuses = {};
      const onOffStatuses = {};
      items.forEach((el: any) => {
        const { self, statuses } = el;
        Object.keys(statuses).map((statusFieldKey: string) => {
          const statusPro: any = statuses[statusFieldKey];
          const status: DeviceStatus =
            statusPro === null || statusPro?.data === null
              ? { id: statusFieldKey }
              : { ...statusPro.data, id: statusPro.self.id };
          switch (statusFieldKey) {
            case DeviceStatusesNames.BCG: {
              bcgStatuses[self.id] = status;
              if (
                (status as any)?.po !== null &&
                (status as any)?.po !== undefined
              )
                postureStatuses[self.id] = parsePosture(
                  (status as any)?.po as number,
                  (status as any)?.datetime
                );
              else postureStatuses[self.id] = EMPTY_POSTURE_STATUS;
              break;
            }
            case DeviceStatusesNames.ACTIVITY: {
              activityStatuses[self.id] = {
                ...status,
                datetime: status["dateTime"]
                  ? status["dateTime"]
                  : status["datetime"],
              } as ActivityStatus;
              break;
            }
            case DeviceStatusesNames.CALIBRATION: {
              callibrationStatuses[self.id] = status;
              break;
            }
            case DeviceStatusesNames.FIRMWARE: {
              firmwareStatuses[self.id] = status;
              break;
            }
            case DeviceStatusesNames.POWER: {
              powerStatuses[self.id] = {
                ...status,
                failure:
                  (status as any)?.batteryFailure === null ||
                  (status as any)?.batteryFailure === undefined
                    ? false
                    : (status as any)?.batteryFailure,
              };
              break;
            }
            case DeviceStatusesNames.SENSORS: {
              sensorsStatuses[self.id] = status;
              break;
            }
            case DeviceStatusesNames.WIFI: {
              wifiStatuses[self.id] = status;
              break;
            }
            case DeviceStatusesNames.BLUETOOTH: {
              bluetoothStatuses[self.id] = status;
              break;
            }
            case DeviceStatusesNames.OCCUPANCY: {
              occupancyStatuses[self.id] = {
                id: DeviceStatusesNames.OCCUPANCY,
                value:
                  status["occupancy"] === 1
                    ? BedStatusValue.IN_BED
                    : BedStatusValue.OUT_OF_BED,
                dateTime: status["dateTime"],
              } as OccupancyStatus;
              break;
            }
            case DeviceStatusesNames.ON_OFF: {
              onOffStatuses[self.id] = status;
              break;
            }
          }
          return null;
        });
      });
      return {
        ...state,
        bcgStatuses,
        callibrationStatuses,
        firmwareStatuses,
        powerStatuses: { ...state.powerStatuses, ...powerStatuses },
        wifiStatuses,
        sensorsStatuses,
        activityStatuses: { ...state.activityStatuses, ...activityStatuses },
        bluetoothStatuses,
        postureStatuses,
        occupancyStatuses,
        onOffStatuses,
        isLoading: false,
      };
    }
    case DEVICES.GET_DEVICE_STATUSES_SUCCESS: {
      const { deviceId, statuses } = (action as IGetDeviceStatusesSuccess)
        .payload;
      const bcgStatuses = {};
      const callibrationStatuses = {};
      const firmwareStatuses = {};
      const powerStatuses = {};
      const wifiStatuses = {};
      const sensorsStatuses = {};
      const activityStatuses = {};
      const bluetoothStatuses = {};
      const postureStatuses = {};
      statuses.map((newSt: DeviceStatus) => {
        switch (newSt.id) {
          case DeviceStatusesNames.BCG: {
            bcgStatuses[deviceId] = newSt;
            if ((newSt as any)?.po !== null && (newSt as any)?.po !== undefined)
              postureStatuses[deviceId] = parsePosture(
                (newSt as any)?.po as number,
                (newSt as any)?.datetime
              );
            else postureStatuses[deviceId] = EMPTY_POSTURE_STATUS;

            break;
          }
          case DeviceStatusesNames.ACTIVITY: {
            activityStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.CALIBRATION: {
            callibrationStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.FIRMWARE: {
            firmwareStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.POWER: {
            powerStatuses[deviceId] = {
              ...newSt,
              failure:
                (newSt as any)?.batteryFailure === null ||
                (newSt as any)?.batteryFailure === undefined
                  ? false
                  : (newSt as any)?.batteryFailure,
            };
            break;
          }
          case DeviceStatusesNames.SENSORS: {
            sensorsStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.WIFI: {
            wifiStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.BLUETOOTH: {
            bluetoothStatuses[deviceId] = newSt;
            break;
          }
        }
        return null;
      });
      return {
        ...state,
        bcgStatuses: { ...state.bcgStatuses, ...bcgStatuses },
        callibrationStatuses: {
          ...state.callibrationStatuses,
          ...callibrationStatuses,
        },
        firmwareStatuses: { ...state.firmwareStatuses, ...firmwareStatuses },
        powerStatuses: { ...state.powerStatuses, ...powerStatuses },
        wifiStatuses: { ...state.wifiStatuses, ...wifiStatuses },
        sensorsStatuses: { ...state.sensorsStatuses, ...sensorsStatuses },
        activityStatuses: { ...state.activityStatuses, ...activityStatuses },
        bluetoothStatuses: { ...state.bluetoothStatuses, ...bluetoothStatuses },
        postureStatuses: { ...state.postureStatuses, ...postureStatuses },
      };
    }
    case DEVICES.GET_DEVICE_STATUS_BY_SOCKET: {
      const { deviceId, status } = action.payload;
      switch (status.id) {
        case DeviceStatusesNames.BCG: {
          const prevStatus = state.bcgStatuses[deviceId];
          return {
            ...state,
            bcgStatuses: {
              ...state.bcgStatuses,
              [deviceId]: {
                ...prevStatus,
                ...status,
              },
            },
          };
        }
        case DeviceStatusesNames.OCCUPANCY: {
          const newData = compareWithPrevious(
            state.occupancyStatuses[deviceId],
            status
          );
          if (newData)
            return {
              ...state,
              occupancyStatuses: {
                ...state.occupancyStatuses,
                [deviceId]: newData,
              },
            };
          return state;
        }
        case DeviceStatusesNames.BLUETOOTH: {
          const newData = compareWithPrevious(
            state.bluetoothStatuses[deviceId],
            status
          );
          if (newData)
            return {
              ...state,
              bluetoothStatuses: {
                ...state.bluetoothStatuses,
                [deviceId]: newData,
              },
            };
          return state;
        }
        case DeviceStatusesNames.ACTIVITY: {
          const newData = compareWithPrevious(
            state.activityStatuses[deviceId],
            status
          );
          return {
            ...state,
            activityStatuses: {
              ...state.activityStatuses,
              [deviceId]: newData,
            },
          };
        }
        case DeviceStatusesNames.CALIBRATION: {
          const prevStatus = state.callibrationStatuses[deviceId];
          return {
            ...state,
            callibrationStatuses: {
              ...state.callibrationStatuses,
              [deviceId]: {
                ...prevStatus,
                ...status,
              },
            },
          };
        }
        case DeviceStatusesNames.FIRMWARE: {
          const newData = compareWithPrevious(
            state.firmwareStatuses[deviceId],
            status
          );
          if (newData)
            return {
              ...state,
              firmwareStatuses: {
                ...state.firmwareStatuses,
                [deviceId]: newData,
              },
            };
          return state;
        }
        case DeviceStatusesNames.POWER: {
          const newData = compareWithPrevious(
            state.powerStatuses[deviceId],
            status
          );
          if (newData)
            return {
              ...state,
              powerStatuses: {
                ...state.powerStatuses,
                [deviceId]: newData,
              },
            };
          return state;
        }
        case DeviceStatusesNames.SENSORS: {
          let newData: SensorsStatus = compareWithPrevious(
            state.sensorsStatuses[deviceId],
            status
          ) as SensorsStatus;
          if (newData) {
            if ((newData as SensorsStatus)?.pir?.isConnected !== undefined) {
              const oldPir = state.sensorsStatuses[deviceId] as SensorsStatus;
              newData = {
                ...newData,
                pir: {
                  ...newData.pir,
                  value: oldPir?.pir?.value,
                  datetime: oldPir?.pir?.datetime,
                },
              };
            }
            return {
              ...state,
              sensorsStatuses: {
                ...state.sensorsStatuses,
                [deviceId]: newData,
              },
            };
          }
          return state;
        }
        case DeviceStatusesNames.WIFI: {
          const prevStatus = state.wifiStatuses[deviceId];
          return {
            ...state,
            wifiStatuses: {
              ...state.wifiStatuses,
              [deviceId]: {
                ...prevStatus,
                ...status,
              },
            },
          };
        }
        case DeviceStatusesNames.POSTURE: {
          if (
            (status as PostureStatus).outOfBody === false &&
            (state.postureStatuses[deviceId] as PostureStatus).outOfBody ===
              false &&
            (status as PostureStatus).value === PostureStatusValue.UNKNOWN
          )
            return state;
          let statusFixed: PostureStatus = status as PostureStatus;
          if ((status as PostureStatus).outOfBody === true)
            statusFixed = {
              ...(status as PostureStatus),
              value: PostureStatusValue.UNATTACHED,
            };
          const newData = compareWithPrevious(
            state.postureStatuses[deviceId],
            statusFixed
          );
          if (newData) {
            // console.log('new posture status' + JSON.stringify(newData));
            return {
              ...state,
              postureStatuses: {
                ...state.postureStatuses,
                [deviceId]: newData,
              },
            };
          }
          return state;
        }
        case DeviceStatusesNames.BIOPATCH_MESSAGE: {
          const bio = status as BioPatchStatus;
          const powerPrev = state.powerStatuses[deviceId];
          const powerChanged = compareWithPrevious(powerPrev, {
            ...powerPrev,
            datetime: bio.Time,
            batteryLevel: bio.BatteryLevel,
          } as PowerStatus);
          const newPower = {
            ...state.powerStatuses,
            [deviceId]: powerChanged ? powerChanged : powerPrev,
          };
          const bcgPrev = state.bcgStatuses[deviceId];
          const bcgChanged = compareWithPrevious(bcgPrev, {
            ...bcgPrev,
            datetime: bio.Time,
            tm: bio.Temperature,
            sp: bio.SpO2,
            hr: bio.HR,
            po: bio.Posture,
          } as BCGStatus);
          const newBCG = {
            ...state.bcgStatuses,
            [deviceId]: bcgChanged ? bcgChanged : bcgPrev,
          };
          const postPrev = state.postureStatuses[deviceId];
          const postureChanged = compareWithPrevious(postPrev, {
            ...postPrev,
            ...parsePosture(
              bio?.OutOfBody === true
                ? PostureStatusNumbers.UNATTACHED
                : bio.Posture, // PostureStatusValue.UNATTACHED
              bio.Time,
              bio?.OutOfBody
            ),
          } as PostureStatus);
          const newPosture = {
            ...state.postureStatuses,
            [deviceId]: postureChanged ? postureChanged : postPrev,
          };
          // if (postureChanged) console.log('BioPatchMessage, new posture' + JSON.stringify(postureChanged));
          const bluePrev = state.bluetoothStatuses[deviceId];
          const blueChanged = compareWithPrevious(postPrev, {
            ...bluePrev,
            bridgeId: bio.BridgeID,
            rssiDbm: bio.RSSI,
            datetime: bio.Time,
          } as BluetoothStatus);
          const newBlue = {
            ...state.bluetoothStatuses,
            [deviceId]: blueChanged ? blueChanged : bluePrev,
          };

          return {
            ...state,
            powerStatuses: newPower,
            bcgStatuses: newBCG,
            postureStatuses: newPosture,
            bluetoothStatuses: newBlue,
          };
        }
        case DeviceStatusesNames.ON_OFF: {
          const newData = compareWithPrevious(
            state.onOffStatuses[deviceId],
            status
          );
          if (newData)
            return {
              ...state,
              onOffStatuses: {
                ...state.onOffStatuses,
                [deviceId]: newData,
              },
            };
          return state;
        }
        case DeviceStatusesNames.USER_NEARBY: {
          const newData =
            JSON.stringify(state.userNearbyStatuses[deviceId]) !==
            JSON.stringify(status)
              ? status
              : undefined;

          if (newData)
            return {
              ...state,
              userNearbyStatuses: {
                ...state.userNearbyStatuses,
                [deviceId]: newData,
              },
            };
          return state;
        }
        case DeviceStatusesNames.USER_NEARBY_SETTINGS: {
          const newData = compareWithPrevious(
            state.userNearbySettingsStatuses[deviceId],
            status
          );
          if (newData)
            return {
              ...state,
              userNearbySettingsStatuses: {
                ...state.userNearbySettingsStatuses,
                [deviceId]: newData,
              },
            };
          return state;
        }
        default:
          return state;
      }
    }
    case DEVICES.ADD_DEVICE_BY_SOCKET:
      const { statuses, id } = (action as IAddDeviceBySocket).payload;
      const deviceId = id;
      const bcgStatuses = {};
      const callibrationStatuses = {};
      const firmwareStatuses = {};
      const powerStatuses = {};
      const wifiStatuses = {};
      const sensorsStatuses = {};
      const activityStatuses = {};
      const bluetoothStatuses = {};
      const postureStatuses = {};
      const onOffStatuses = {};
      if (!statuses) return state;
      Object.keys(statuses).map((key: string) => {
        const newStUnmap: any = statuses[key];
        const newSt = { ...newStUnmap?.data };
        switch (newStUnmap?.self?.id) {
          case DeviceStatusesNames.BCG: {
            bcgStatuses[deviceId] = newSt;
            if ((newSt as any)?.po !== null && (newSt as any)?.po !== undefined)
              postureStatuses[deviceId] = parsePosture(
                (newSt as any)?.po as number,
                (newSt as any)?.datetime
              );
            else postureStatuses[deviceId] = EMPTY_POSTURE_STATUS;

            break;
          }
          case DeviceStatusesNames.ACTIVITY: {
            activityStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.CALIBRATION: {
            callibrationStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.FIRMWARE: {
            firmwareStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.POWER: {
            powerStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.SENSORS: {
            sensorsStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.WIFI: {
            wifiStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.BLUETOOTH: {
            bluetoothStatuses[deviceId] = newSt;
            break;
          }
          case DeviceStatusesNames.ON_OFF: {
            onOffStatuses[deviceId] = newSt;
            break;
          }
        }
        return null;
      });
      return {
        ...state,
        bcgStatuses: { ...state.bcgStatuses, ...bcgStatuses },
        callibrationStatuses: {
          ...state.callibrationStatuses,
          ...callibrationStatuses,
        },
        firmwareStatuses: { ...state.firmwareStatuses, ...firmwareStatuses },
        powerStatuses: { ...state.powerStatuses, ...powerStatuses },
        wifiStatuses: { ...state.wifiStatuses, ...wifiStatuses },
        sensorsStatuses: { ...state.sensorsStatuses, ...sensorsStatuses },
        activityStatuses: { ...state.activityStatuses, ...activityStatuses },
        bluetoothStatuses: { ...state.bluetoothStatuses, ...bluetoothStatuses },
        postureStatuses: { ...state.postureStatuses, ...postureStatuses },
        onOffStatuses: { ...state.onOffStatuses, ...onOffStatuses },
      };
    case DEVICES.DELETE_DEVICE_BY_SOCKET: {
      const data: DeviceResidentDTO = (action as IDeleteDeviceBySocket).payload;
      const activityStatuses = state.activityStatuses;
      if (state.activityStatuses[data.deviceId])
        delete activityStatuses[data.deviceId];
      const bcgStatuses = state.bcgStatuses;
      if (state.bcgStatuses[data.deviceId]) delete bcgStatuses[data.deviceId];
      const callibrationStatuses = state.callibrationStatuses;
      if (state.callibrationStatuses[data.deviceId])
        delete callibrationStatuses[data.deviceId];
      const firmwareStatuses = state.firmwareStatuses;
      if (state.firmwareStatuses[data.deviceId])
        delete firmwareStatuses[data.deviceId];
      const powerStatuses = state.powerStatuses;
      if (state.powerStatuses[data.deviceId])
        delete powerStatuses[data.deviceId];
      const sensorsStatuses = state.sensorsStatuses;
      if (state.sensorsStatuses[data.deviceId])
        delete sensorsStatuses[data.deviceId];
      const wifiStatuses = state.wifiStatuses;
      if (state.wifiStatuses[data.deviceId]) delete wifiStatuses[data.deviceId];
      return {
        ...state,
        bcgStatuses,
        callibrationStatuses,
        firmwareStatuses,
        powerStatuses,
        wifiStatuses,
        sensorsStatuses,
        activityStatuses,
      };
    }
    case DEVICES.GET_USER_TAG_DEVICES_SUCCESS: {
      const res = action.payload;
      const activity = { ...state.activityStatuses };
      const blue = { ...state.bluetoothStatuses };
      const power = { ...state.powerStatuses };
      try {
        res.map((el) => {
          const { statuses } = el;
          if (statuses?.activity) {
            activity[el?.productId] = {
              id: DeviceStatusesNames.ACTIVITY,
              ...statuses?.activity,
            } as ActivityStatus;
          }
          if (statuses?.power) {
            power[el?.productId] = {
              id: DeviceStatusesNames.POWER,
              ...statuses?.power,
            } as PowerStatus;
          }
          if (statuses?.bluetooth) {
            blue[el?.productId] = {
              id: DeviceStatusesNames.BLUETOOTH,
              ...statuses?.bluetooth,
            } as BluetoothStatus;
          }
          return null;
        });
        return {
          ...state,
          activityStatuses: activity,
          bluetoothStatuses: blue,
          powerStatuses: power,
        };
      } catch (e) {
        console.log("guess who" + JSON.stringify(e));
      }
      return state;
    }
    case DEVICES.GET_USER_NEARBY_SUCCESS: {
      const items = action.payload;
      const userNearbyStatuses = {};
      Object.keys(items).map((deviceId) => {
        const data = items[deviceId];
        if (Array.isArray(data)) {
          userNearbyStatuses[deviceId] = {
            id: DeviceStatusesNames.USER_NEARBY,
            nearBed: data,
          } as UserNearbyStatus;
        } else if (data?.nearBed || data?.nearRoom) {
          const nearRoom: any[] = data?.nearRoom || [];
          const nearBed: any[] = data?.nearBed || [];

          const nearRoomWithout = nearRoom.filter((room) => {
            return nearBed.findIndex((bed) => bed.id === room.id) === -1;
          });
          const full = nearRoom.concat(nearRoomWithout);
          if (Array.isArray(full) && full?.length) {
            userNearbyStatuses[deviceId] = {
              id: DeviceStatusesNames.USER_NEARBY,
              nearBed,
              nearRoom: nearRoomWithout,
            } as UserNearbyStatus;
          }
        }
        return null;
      });
      return { ...state, userNearbyStatuses };
    }

    case DEVICES.GET_USER_NEARBY_SETTINGS_SUCCESS: {
      const items = action.payload;
      const userNearbySettingsStatuses = {};
      Object.keys(items).map((deviceId) => {
        const data = items[deviceId];

        userNearbySettingsStatuses[deviceId] = {
          id: DeviceStatusesNames.USER_NEARBY_SETTINGS,
          bedDistance: data?.bedDistance,
          roomDistance: data?.roomDistance,
          blockFallPrevantion: data?.blockFallPrevantion,
        } as UserNearbySettingsStatus;
        return null;
      });
      return { ...state, userNearbySettingsStatuses };
    }

    default:
      return state;
  }
};

const compareWithPrevious = (
  prevStatus: DeviceStatus,
  status: DeviceStatus
) => {
  if (!prevStatus) return status;
  const prev = {};
  const now = {};
  Object.keys(prevStatus).map((key: any) => {
    if (key !== "datetime") prev[key] = prevStatus[key];
    return null;
  });
  Object.keys(status).map((key: any) => {
    if (key !== "datetime") now[key] = status[key];
    return null;
  });
  let somethingChange = false;
  Object.keys(now).map((key: any) => {
    if (now[key] !== prev[key]) somethingChange = true;
    return null;
  });
  if (JSON.stringify(prev) === JSON.stringify(now) || !somethingChange) {
    // console.log('status didnt change');
    return undefined;
  }
  // console.log(JSON.stringify(prev));
  // console.log(JSON.stringify(now));
  return {
    ...prevStatus,
    ...status,
  };
};
export default reducer;
